<template>
  <div class="w-full space-y-6">
    <div class="grid grid-cols-10 gap-6">
      <div class="col-span-10">
        <label class="block text-sm font-medium text-gray-700 mb-1">About the session</label>
        <span class="text-sm text-gray-700">Provide objectives, setting, and expected skills</span>
        <div class="relative">
          <QuillEditor
            data-cy="session-details-about"
            ref="session"
            theme="snow"
            v-model:content="about_the_session"
            @editorChange="changingSessionContent('about_the_session')"
            @textChange="limitCharacters('session')"
            contentType="html"
          />
          <CharacterCount :section="about_the_session"></CharacterCount>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.prod.css';
import CharacterCount from '../Inputs/CharacterCount.vue';
import { MAX_CHAR_LENGTH } from '@/Utils/vice-constants';

export default {
  name: 'SessionDetails',
  components: {
    QuillEditor,
    CharacterCount,
  },
  data() {
    return {
      about_the_session: this.$page.props.session
        ? this.$page.props.session.about?.about_the_session
        : '',
    };
  },
  methods: {
    changingSessionContent(type) {
      this.$emit('changeSessionContent', { type, content: this[type] });
    },
    limitCharacters(type) {
      const quill = this.$refs[type].getQuill();
      if (quill.getLength() > MAX_CHAR_LENGTH) {
        quill.deleteText(MAX_CHAR_LENGTH, quill.getLength());
      }
    },
  },
};
</script>

<style>
.ql-container,
.ql-editor {
  min-height: 200px;
}
</style>
